<template>
    <span>
        <button :class="getCSSClass('record-details-button')"
                v-on:click="showDetails"
                type="button"
                v-html="buttonIcon"
        ></button>
        <popup :visible="showPopup"
               v-on:close="showPopup = false">
            <div v-if="loading" v-html="loadingIndicator"></div>
            <template v-else>
                <div v-if="this.subjectData != null"  :class="getCSSClass('record-details-container')">
                    <div :class="getCSSClass('record-details-header')">
                        <span :class="getCSSClass('record-details-header-label')" v-html="translate('Zenedarabok')+': '+subjectData.title"></span>
                        <music-contributor-manager-button
                                :class="getCSSClass('add-song-to-record-button')"
                                :title="translate('Új zenedarab')"
                                :operations-url="contributorUrl"
                                :subject="{}"
                                v-on:notify="reloadList"
                                :parent="subject"
                                :button-icon="icon('add')"></music-contributor-manager-button>

                        <button :class="getCSSClass('record-details-close-button')"
                                v-on:click="showPopup = false"
                                type="button"
                                v-html="icon('close')+translate('Bezár')"
                        ></button>
                    </div>
                    <div :class="getCSSClass('record-details-body')">
                        <div :class="getCSSClass('record-details-songs-row')">
                            <table :class="getCSSClass('record-details-songs-table')">
                                <thead :class="getCSSClass('record-details-songs-table-head')">
                                <tr>
                                    <th v-html="translate('Ssz')"></th>
                                    <th v-html="translate('Zenedarab')"></th>
                                    <th v-html="translate('Műveletek')"></th>
                                </tr>
                                </thead>
                                <tbody :class="getCSSClass('record-details-songs-table-body')"
                                       :style="{'opacity': moving ? '.5' : '1'}"
                                >
                                    <tr v-for="song, songIndex in subjectData.songs"
                                        :class="getCSSClass('record-details-song-row')"
                                    >
                                        <td v-html="song.position"></td>
                                        <td v-html="song.title"></td>
                                        <td>
                                            <div :class="getCSSClass('record-details-operations-container')">
                                                <music-contributor-manager-button
                                                        :title="translate('Adatok')"
                                                        :operations-url="contributorUrl"
                                                        :subject="song"
                                                        v-on:notify="reloadList"
                                                        :parent="subject"
                                                        :button-icon="icon('edit')"></music-contributor-manager-button>
                                                <button v-if="songIndex > 0"
                                                        :class="getCSSClass('record-details-move-up-button')"
                                                        v-on:click="moveSong(song.id, -1)"
                                                        v-html="icon('arrow-up')"
                                                ></button>
                                                <button v-if="songIndex < subjectData.songs.length - 1"
                                                        :class="getCSSClass('record-details-move-down-button')"
                                                        v-on:click="moveSong(song.id, 1)"
                                                        v-html="icon('arrow-down')"
                                                ></button>
                                                <button :class="getCSSClass('record-details-delete-button')"
                                                        v-on:click="confirmDeletion(song)"
                                                        v-html="icon('delete')"
                                                ></button>
                                            </div>

                                        </td>
                                    </tr>

                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
            </template>
            <popup :visible="showDeleteConfirmation"
                   v-on:close="showDeleteConfirmation = false">
                <model-manager-delete-confirmation-form
                        v-if="selectedSongId > 0"
                        :label="deleteLabel"
                                                        :buttons="mainButtons"
                                                        v-on:confirmed="deleteSong"
                                                        v-on:canceled="cancelDeletion"
                ></model-manager-delete-confirmation-form>

            </popup>
        </popup>
    </span>
</template>

<script>
    export default {
        inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon', 'mainButtons'],
        props: {
            operationsUrl: {type: String},
            contributorUrl: {type: String},
            subject: {},
            buttonIcon: {type: String}
        },
        data: function () {
            return {
                showPopup: false,
                subjectData: null,
                loading: true,
                moving: false,
                showDeleteConfirmation: false,
                deleteLabel: '',
                selectedSongId: -1,
            }
        },
        mounted() {
        },
        methods: {
            reloadList: function() {
                this.loading = true;
                this.fetchSubject(() => {
                    this.loading = false;
                })
            },
            recordOrSongField: function(song, field) {
                if (song[field] != '') {
                    return song[field];
                }
                return this.subjectData[field];
            },
            showDetails: function() {
                this.fetchSubject(() => {
                    this.showPopup = true;
                })
            },
            confirmDeletion: function(song) {
                this.deleteLabel = this.translate('Biztosan törli a(z) :subject zenedarabot?', {subject: song.title});
                this.selectedSongId = song.id;
                this.showDeleteConfirmation = true;
            },
            cancelDeletion: function() {
                this.deleteLabel = '';
                this.selectedSongId = -1;
                this.showDeleteConfirmation = false;
            },

            moveSong: function(songId, direction) {
                this.moving = true;
                window.axios.post(this.currentUrl, {action: 'move', direction: direction, songid: songId})
                    .then((response) => {
                        this.subjectData.songs = response.data;
                        this.moving = false;
                    });
            },
            deleteSong: function() {
                this.moving = true;
                window.axios.post(this.currentUrl, {action: 'delete', songid: this.selectedSongId})
                    .then((response) => {
                        this.subjectData.songs = response.data;
                        this.selectedSongId = -1;
                        this.moving = false;
                        this.showDeleteConfirmation = false;
                    });
            },

            fetchSubject: function(callback = null) {
                window.axios.get(this.currentUrl)
                    .then((response) => {
                        this.subjectData = response.data;
                        this.loading = false;
                        if (callback) {
                            callback();
                        }
                    })
            }
        },
        computed: {
            currentUrl: function() {
                return this.operationsUrl.replace('___id___', this.subject.id);
            }
        },
        watch: {
            showPopup: function(value) {
                if (!value) {
                    this.subjectData = null;
                }
            }
        }

    }
</script>
